import type { AppTufs } from '@gmao/types';
import { useSharedClient } from '@shared/client';

export * from '@shared/client';

export const client = useSharedClient<AppTufs>();
